import UpdatedPriceDetails from "./UpdatedPriceDetails"
import OriginalPriceDetails from "./OriginalPriceDetails"
import { Flex, Button } from "antd"
import { spacings } from "themes/variables"
import styles from "./index.module.css"
import PropTypes from "prop-types"
import { useTranslation } from "react-i18next"
import { useState } from "react"
import { Icon } from "ui/Icon"

const PriceChangeHistory = ({ originalPriceHistory, priceChangeHistories }) => {
  const { t } = useTranslation()
  const [isPriceChangeHistoryVisible, setIsPriceChangeHistoryVisible] = useState(false)
  const priceChangeHistoryText = isPriceChangeHistoryVisible
    ? t("client.payment.labels.hide_price_change_history")
    : t("client.payment.labels.show_price_change_history")

  if (!priceChangeHistories?.length) return null

  return (
    <Flex vertical>
      <Button
        variant="outlined"
        color="primary"
        className="w-fit m-s"
        onClick={() => setIsPriceChangeHistoryVisible(!isPriceChangeHistoryVisible)}
      >
        {priceChangeHistoryText} <Icon type="feather" name={isPriceChangeHistoryVisible ? "ChevronUp" : "ChevronDown"} />
      </Button>
      {isPriceChangeHistoryVisible && (
        <Flex vertical gap={spacings.XS} className={`${styles.priceChangeHistoryContainer} mx-xxs my-xs`}>
          <UpdatedPriceDetails priceChangeHistories={priceChangeHistories} />
          <OriginalPriceDetails originalPriceHistory={originalPriceHistory} />
        </Flex>
      )}
    </Flex>
  )
}

PriceChangeHistory.propTypes = {
  originalPriceHistory: PropTypes.array,
  priceChangeHistories: PropTypes.array
}

export default PriceChangeHistory
